<template>
  <div>
    <div class="project" v-for="(value, key) in homeByProjects">
      <div class="project-name">โครงการ {{ key }}</div>
      <div class="home" v-for="home in value">
        <div>บ้านเลขที่: {{ home.addressNumber }}</div>
        <div>Home ID: {{ home.id }}</div>
        <div>{{ home.userRole }}</div>
        <div>
          <sc-button variant="danger" size="sm" @click="handleClickRemove(home)"
            >ไล่ออก</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userRoleMapper } from "@/lib/mapper";
import ScButton from "@/lib/components/ScButton";

export default {
  components: {
    ScButton
  },
  props: ["homes"],
  computed: {
    homeByProjects() {
      const homeByProjectName = this.homes.reduce((all, home) => {
        const nHome = { ...home, userRole: userRoleMapper[home.userRole] };
        if (all[home.projectName]) {
          all[home.projectName].push(nHome);
        } else {
          all[home.projectName] = [nHome];
        }

        return all;
      }, {});

      return homeByProjectName;
    }
  },
  methods: {
    handleClickRemove(home) {
      this.$emit("remove", home);
    }
  }
};
</script>

<style lang="scss" scoped>
.project {
  margin-bottom: 30px;
}

.project-name {
  font-weight: bold;
}

.home {
  display: grid;
  grid-template-columns: 170px 150px 1fr 100px;
  grid-gap: 15px;

  padding: 8px 0;

  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/components/HomeList.vue